import ModalOrg from 'antd/lib/modal';
import { ModalFunc, ModalFuncProps } from 'antd/lib/modal/Modal';

import Mousetrap from 'mousetrap';
import 'mousetrap/plugins/pause/mousetrap-pause';


export default class Modal extends ModalOrg {
    // static confirm: ModalFunc;
    static _commonFunc(func: ModalFunc, props: ModalFuncProps): {
        destroy: () => void;
        update: (newConfig: ModalFuncProps) => void;
    } {
        Mousetrap.pause();
        const onOk = props.onOk;
        const onCancel = props.onCancel;
        const onOkNew: any = () => {
            if (onOk !== undefined) onOk();
            Mousetrap.unpause();
        };
        const onCancelNew: any = () => {
            if (onCancel !== undefined) onCancel();
            Mousetrap.unpause();
        };
        return func({ ...props, onOk: onOkNew, onCancel: onCancelNew });
    }
}
Modal.info = (props) => {
    return Modal._commonFunc(ModalOrg.info, props);
};
Modal.success = (props) => {
    return Modal._commonFunc(ModalOrg.success, props);
};
Modal.error = (props) => {
    return Modal._commonFunc(ModalOrg.error, props);
};
Modal.warn = (props) => {
    return Modal._commonFunc(ModalOrg.warn, props);
};
Modal.warning = (props) => {
    return Modal._commonFunc(ModalOrg.warning, props);
};
Modal.confirm = (props) => {
    return Modal._commonFunc(ModalOrg.confirm, props);
};
